<template>
  <div class="messenger-icon fs-3 position-fixed d-md-block d-none">
    <a href="#" class="rounded-circle d-block"
      ><i class="bi bi-messenger text-light"></i
    ></a>
  </div>
</template>

<style lang="scss">
.messenger-icon {
  bottom: 40px;
  right: 40px;
  z-index: 2;
  a {
    box-shadow: 0 4px 20px #5d81aba6;
    background: linear-gradient(to right, #4653a1, #3283c2);
    padding: 2px 8px;
  }
}
</style>
